"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var extentValue = exports.extentValue = function extentValue(extent) {
  return extent && extent.extent || Array.isArray(extent) && extent || [];
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/semiotic/lib/data/unflowedFunctions.js
// module id = 301
// module chunks = 0